'use client';
import { Button } from '@svenskaspelab/ui/react/button';
import Pix from '@svenskaspelab/ui/react/icons/Pix';
import { type ReactNode } from 'react';

import type { CouponIndex } from '../../schema/coupon/entry.js';

type PixSrowCouponButtonProps = {
  couponIndex: CouponIndex;
  handleOnClick: () => void;
};

/**
 * Element containing a button to fill a coupon row with Pix.
 *
 * @param root0 Object containing the function to fill coupon row with Pix
 * @param root0.couponIndex Index of the coupon row to be filled
 * @param root0.handleOnClick Function to fill the coupon row with Pix when the button is clicked
 * @returns JSX.Element
 */
export default function PixSrowCouponButton({ couponIndex, handleOnClick }: PixSrowCouponButtonProps): ReactNode {
  return (
    <Button
      className="z-2"
      variant="outline"
      name="quickPickSingleRow"
      type="button"
      onClick={handleOnClick}
      aria-label={`Fyll i rad ${couponIndex + 1} med PIX!`}
    >
      <Pix />
    </Button>
  );
}
